// react
import { useContext, useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { CashInMethod, Pagination } from '../../../../../@types';

// router
import { useSearchParams } from 'react-router-dom';

// context
import { ContextProject } from '../../Project.context';

// hooks
import { useFetch } from '../../../../../hooks/useFetch';

// mui
import { Alert, Container, Grid, Paper, Typography } from '@mui/material';

// tables
import { TableBasicCashInMethods } from '../../../../tables/basic/TableBasicCashInMethods/TableBasicCashInMethods';

// dialogs
import { DialogAddCashInMethod } from '../../../../dialogs/DialogAddCashInMethod/DialogAddCashInMethod';

// utils
import { defaultPagination } from '../../../../../utils/defaults';

export const CashInMethods = () => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const [searchParams, setSearchParams] = useSearchParams();
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	// params
	const paramPage = Number(searchParams.get('page') || 1);
	const paramDialog = searchParams.get('dialog');

	// state
	const [cashInMethods, setCashInMethods] = useState<CashInMethod[]>([]);
	const [pagination, setPagination] = useState<Pagination>({
		...defaultPagination,
		perPage: 5,
	});

	// fetch cash-in methods
	const urlCashInMethods = `${process.env.REACT_APP_API_URL}/cash-in-methods?project=${project?.id},null&page=${paramPage}&limit=${pagination.perPage}`;

	const { isLoading, refetch: refetchCashInMethods } = useFetch({
		isEnabled: Boolean(project),
		url: urlCashInMethods,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setCashInMethods(res.data);
			}

			if (res.pagination) {
				setPagination(res.pagination);
			}
		},
	});

	// dialog handlers
	const handleCloseDialog = () => {
		searchParams.delete('dialog');
		setSearchParams(searchParams);
	};

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Paper
						sx={(theme) => {
							return {
								padding: theme.spacing(2),
								height: '100%',
							};
						}}>
						<Grid
							alignItems="stretch"
							container
							direction="column"
							spacing={2}
							sx={{ height: 'calc(100% + 16px)' }}>
							<Grid item>
								<Typography variant="h3">{t('cashInMethods')}</Typography>
							</Grid>
							<Grid item flex={1}>
								<TableBasicCashInMethods
									borderRadius={2}
									color="grey"
									data={cashInMethods}
									hasBorder={true}
									hasStripes={true}
									isLoading={isLoading}
									refetchCashInMethods={refetchCashInMethods}
									TableFooterProps={{
										numShowing: cashInMethods.length,
										pagination,
									}}
								/>
							</Grid>
							<Grid item>
								<Alert severity="info">{t('alert.cashInMethodsDynamic')}</Alert>
							</Grid>
						</Grid>
					</Paper>
				</Grid>
			</Grid>
			<DialogAddCashInMethod
				isOpen={paramDialog === 'addCashInMethod'}
				onClose={handleCloseDialog}
				onSuccess={() => {
					refetchCashInMethods();
					handleCloseDialog();
				}}
			/>
		</Container>
	);
};
